// Get all organizations
export const getAllOrganizationConfig = () => ({
  url: `/getallorganizations`,
});

export const getAllOrganizationPaginationConfig = (itemsPerPage) => ({
  url: `/getallorganizations?page=1&per_page=${itemsPerPage}&sort_by=start_date&sort_direction=desc`,
});

// Get By Id organizations
export const getOrganizationByIdConfig = (id) => ({
  url: `/get_organization/${id}`,
});

// Get all active organizations
export const getAllActiveOrganizationConfig = () => ({
  url: `/organizations`,
});

// Create organization
export const uploadOrganizationLogo = () => ({
  url: `/organization/upload_logo`,
});

// Create organization
export const addOrganizationConfig = () => ({
  url: `/organization`,
});

//delete organization
export const deleteOrganizationConfig = (id) => ({
  url: `/delete_organization/${id}`,
});

//edit organization
export const editOrganizationConfig = (id) => ({
  url: `/organization/${id}`,
});

export const defaultNotificationTemplatesConfig = () => ({
  url: `/notification/temp`,
});

export const filterOrganizationApiConfig = () => ({
  url: `/filter_orgs`,
});

export const ehrFilterOrganizationConfig = () => ({
  url: `/ehr`,
});

export const getFronteggPlansConfig = () => ({
  url: `/frontegg_plans`,
});

export const getMirrorOrganizationConfig = () => ({
  url: `/mirror_org`,
});
